import React from 'react';
import { NavLink } from "react-router-dom";
import './header.css';


function Navbar(props) {
    return (
        <nav>
            <ul>
                <li><NavLink to="/about">About</NavLink></li>
                <li><NavLink to="/contact">Contacts</NavLink></li>
                <li><NavLink to="/advrtise">Advertise</NavLink></li>
            </ul>
        </nav>
    );
}

export default Navbar;